<template>
  <div>
    <app-header-container>
      {{ $t('views.Dashboard.Documentation.title') }}
    </app-header-container>
    <documentation></documentation>
  </div>
</template>
<script>
import AppHeaderContainer from '@/ui/layout/AppHeaderContainer'
import Documentation from '@/components/Documentation'

import forwardMoreOnMobile from '@/mixins/forwardMoreOnMobile'

export default {
  mixins: [forwardMoreOnMobile],

  components: {
    AppHeaderContainer,
    Documentation
  }
}
</script>
